module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_1-ca6d229232fa1c242a67367b98e7f77f.jpg";